import React from 'react';
import { SparklesIcon, GiftIcon, TrendingUpIcon, CalendarIcon } from 'lucide-react';
export function LoyaltyPointsSection() {
  const currentPoints = 2450;
  const tierProgress = 65;
  const nextTierPoints = 3000;
  const pointsHistory = [{
    id: 1,
    description: 'Purchase - Order #000013951',
    points: 26,
    date: '2024-01-15',
    type: 'earned'
  }, {
    id: 2,
    description: 'Purchase - Order #000013950',
    points: 25,
    date: '2024-01-10',
    type: 'earned'
  }, {
    id: 3,
    description: 'Birthday Bonus',
    points: 100,
    date: '2024-01-05',
    type: 'bonus'
  }, {
    id: 4,
    description: 'Redeemed - 10% Discount Voucher',
    points: -500,
    date: '2024-01-03',
    type: 'redeemed'
  }];
  return <div className="space-y-6" data-id="element-699" data-mp="1ri3ef9uhw1kp">
      {/* Points Balance Card */}
      <div className="bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] rounded-xl shadow-lg p-6 text-white" data-id="element-700" data-mp="1mjs3swwdln1f">
        <div className="flex items-center gap-2 mb-4" data-id="element-701" data-mp="3tif6gbbkvx50">
          <SparklesIcon className="w-6 h-6 text-yellow-300" data-id="element-702" data-mp="3tguach9m8651" />
          <h2 className="text-lg font-bold" data-id="element-703" data-mp="25axauq4eqhh">Loyalty Points</h2>
        </div>
        <div className="mb-6" data-id="element-704" data-mp="3kisbo8dctpkx">
          <p className="text-sm text-blue-200 mb-1" data-id="element-705" data-mp="3kjk08z8jan1p">Available Points</p>
          <p className="text-4xl font-bold" data-id="element-706" data-mp="3oj2i1m526i0b">{currentPoints.toLocaleString()}</p>
        </div>
        {/* Tier Progress */}
        <div className="mb-4" data-id="element-707" data-mp="g5byyce7m1y0">
          <div className="flex justify-between items-center mb-2" data-id="element-708" data-mp="g1y0hf8o2cvu">
            <span className="text-sm text-blue-100" data-id="element-709" data-mp="l1u4vfla06bx">Progress to Gold Tier</span>
            <span className="text-sm font-bold text-yellow-300" data-id="element-710" data-mp="745k07r7kz6v">
              {tierProgress}%
            </span>
          </div>
          <div className="w-full h-3 bg-white bg-opacity-20 rounded-full overflow-hidden" data-id="element-711" data-mp="c0vywrra1oqp">
            <div className="h-full bg-gradient-to-r from-yellow-300 to-yellow-500 transition-all duration-500" style={{
            width: `${tierProgress}%`
          }} data-id="element-712" data-mp="2rs08gqxvg0o3" />
          </div>
          <p className="text-xs text-blue-100 mt-2" data-id="element-713" data-mp="12eahoo4ypayf">
            {nextTierPoints - currentPoints} points to next tier
          </p>
        </div>
      </div>
      {/* Points History */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-714" data-mp="skjqvcld4ofk">
        <div className="p-5 border-b border-gray-200" data-id="element-715" data-mp="okjdzwdwwlam">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-716" data-mp="jmhkehiv13kw">Points History</h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-717" data-mp="en4zw3fgo8lh">
          {pointsHistory.map(item => <div key={item.id} className="p-5 hover:bg-gray-50 transition-colors" data-id="element-718" data-mp="9nsabax7gnf7">
              <div className="flex items-center justify-between" data-id="element-719" data-mp="5myr2uupjwsn">
                <div className="flex items-center gap-3" data-id="element-720" data-mp="241tabz4hrggv">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.type === 'redeemed' ? 'bg-red-100' : 'bg-green-100'}`} data-id="element-721" data-mp="2419ssjir6u3d">
                    {item.type === 'bonus' ? <GiftIcon className="w-5 h-5 text-purple-600" data-id="element-722" data-mp="3mwxstv72ti9t" /> : item.type === 'redeemed' ? <SparklesIcon className="w-5 h-5 text-red-600" data-id="element-723" data-mp="3rne6nget75wp" /> : <TrendingUpIcon className="w-5 h-5 text-green-600" data-id="element-724" data-mp="3vpreqbh13fwn" />}
                  </div>
                  <div data-id="element-725" data-mp="2z00erwpyx0jg">
                    <p className="font-medium text-gray-900" data-id="element-726" data-mp="2z0teidqieps3">
                      {item.description}
                    </p>
                    <p className="text-sm text-gray-600 flex items-center gap-1" data-id="element-727" data-mp="37zn7lu4msy0w">
                      <CalendarIcon className="w-3 h-3" data-id="element-728" data-mp="381rn79bw7lh0" />
                      {item.date}
                    </p>
                  </div>
                </div>
                <p className={`font-bold ${item.points > 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-729" data-mp="n8eg00hhdjb6">
                  {item.points > 0 ? '+' : ''}
                  {item.points}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}